export default "__VITE_ASSET__0edae30a__"